import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button } from "@mui/material";
import { PaymentAction } from "./PaymentAction";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(month, status, action) {
  return { month, status, action };
}

const MonthsArr = [
  "JANUARY ",
  "FEBRUARY ",
  "MARCH ",
  "APRIL ",
  "MAY ",
  "JUNE ",
  "JULY ",
  "AUGUST ",
  "SEPTEMBER ",
  "OCTOBER ",
  "NOVEMBER ",
  "DECEMBER ",
];

function calculateMonthDuration(year, month) {
  const today = new Date();
  const targetDate = new Date(year, month);

  const diffInMonths =
    (today.getFullYear() - targetDate.getFullYear()) * 12 +
    (today.getMonth() - targetDate.getMonth());

  return diffInMonths;
}

export default function CustomizedTables(props) {
  const payments = props.payments;
  let rows = [];
  let duration = null;
  const user = JSON.parse(sessionStorage.getItem("user"));

  if (payments.length > 0) {
    rows = payments.map((payment) => {
      return createData(
        MonthsArr[parseInt(payment.month)] + payment.year,
        payment.status.toUpperCase(),
        <PaymentAction paymentStatus={payment.status} paymentObj={payment} />
      );
    });
    const lastPaymnet = payments[payments.length - 1];
    duration = calculateMonthDuration(
      parseInt(lastPaymnet.year),
      parseInt(lastPaymnet.month)
    );
    for (let i = 0; i < duration; i++) {
      const month = parseInt(lastPaymnet.month) + i + 1;
      const year = parseInt(lastPaymnet.year);
      const userId = user?._id;
      const classType = user?.classType;

      const paymentObj = {
        userId,
        month,
        year,
        classType,
        status: "notpaid",
      };
  
      rows.push(
        createData(
          MonthsArr[month % 12] + (month % 12 === 0 ? year + 1 : year),
          "NOT PAID",
          <PaymentAction paymentStatus={"notpaid"} paymentObj={paymentObj} />
        )
      );
     
    }
  }

  //for first time payment
  if (payments.length === 0) {
    const today = new Date();
    const month = today.getMonth();
    const year = today.getFullYear();
    const userId = user?._id;
    const classType = user?.classType;

    const paymentObj = {
      userId,
      month,
      year,
      classType,
      status: "notpaid",
    };
    rows.push(
      createData(
        MonthsArr[month] + year,
        "Not Paid",
        <PaymentAction paymentStatus={"notpaid"} paymentObj={paymentObj} />
      )
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 500 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Month</StyledTableCell>
            <StyledTableCell align="right">Payment Status</StyledTableCell>
            <StyledTableCell align="right">Action</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length > 0 &&
            rows.map((row) => (
              <StyledTableRow key={row.name}>
                <StyledTableCell component="th" scope="row">
                  {row.month}
                </StyledTableCell>
                <StyledTableCell align="right">{row.status}</StyledTableCell>
                <StyledTableCell align="right">{row.action}</StyledTableCell>
              </StyledTableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
